import { useState } from 'react'
import { SelectorUbicacion } from '@/modules/ordenes-servicio/SelectorUbicacion'
import { IconoCerrar } from '@/shared/ui/Iconos/Iconos'
import { CampoPesos } from './CampoPesos'
import estilos from './PlanProyectos.module.css'

type PropsPanel = {
  abierto: boolean
  onCerrar: () => void
  onCrear: (datos: {
    codigo: string
    nombre: string
    cliente: string
    ubicacion: string
    fecha_inicio: string
    fecha_fin: string
    presupuesto: number
    latitud?: number | null
    longitud?: number | null
    radio_geocerca_m?: number | null
  }) => void
}

export function PanelNuevoProyectoInline({ abierto, onCerrar, onCrear }: PropsPanel) {
  const [codigo, setCodigo] = useState('')
  const [nombre, setNombre] = useState('')
  const [cliente, setCliente] = useState('')
  const [ubicacion, setUbicacion] = useState('')
  const [fechaInicio, setFechaInicio] = useState(new Date().toISOString().slice(0, 10))
  const [fechaFin, setFechaFin] = useState(() => {
    const d = new Date()
    d.setMonth(d.getMonth() + 2)
    return d.toISOString().slice(0, 10)
  })
  const [presupuesto, setPresupuesto] = useState(0)
  const [punto, setPunto] = useState<{ lat: number; lng: number } | null>(null)
  const [radioGeocerca, setRadioGeocerca] = useState(80)

  if (!abierto) return null

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!nombre.trim()) return
    onCrear({
      codigo: codigo.trim() || `PROY-${Date.now().toString().slice(-4)}`,
      nombre: nombre.trim(),
      cliente: cliente.trim(),
      ubicacion: ubicacion.trim(),
      fecha_inicio: fechaInicio,
      fecha_fin: fechaFin,
      presupuesto: Number(presupuesto) || 0,
      latitud: punto?.lat ?? null,
      longitud: punto?.lng ?? null,
      radio_geocerca_m: punto ? radioGeocerca : 80,
    })
    onCerrar()
  }

  return (
    <section className={estilos.panelNuevoProyectoInline} aria-label="Crear nuevo proyecto">
      <header className={estilos.panelInlineHeader}>
        <div className={estilos.panelInlineTitulo}>
          <span className={estilos.badgeSombra}>Formulario en Línea</span>
          <h3>Crear Nuevo Proyecto</h3>
        </div>
        <button
          type="button"
          className={estilos.btnCerrarInline}
          onClick={onCerrar}
          title="Cerrar formulario"
        >
          <IconoCerrar />
        </button>
      </header>

      <form onSubmit={handleSubmit} className={estilos.panelInlineForm}>
        <div className={estilos.panelInlineGrid}>
          <div className={estilos.campo}>
            <label>Código del proyecto</label>
            <input
              type="text"
              placeholder="Ej: PROY-2026-OBRA"
              value={codigo}
              onChange={(e) => setCodigo(e.target.value)}
            />
          </div>

          <div className={estilos.campoGrande}>
            <label>Nombre del proyecto *</label>
            <input
              type="text"
              required
              autoFocus
              placeholder="Ej: Redes Hidrosanitarias Plaza de Mercado"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
            />
          </div>

          <div className={estilos.campo}>
            <label>Cliente / Solicitante</label>
            <input
              type="text"
              placeholder="Ej: Alcaldía Municipal"
              value={cliente}
              onChange={(e) => setCliente(e.target.value)}
            />
          </div>

          <div className={estilos.campo}>
            <label>Ubicación / Municipio</label>
            <input
              type="text"
              placeholder="Ej: Cartago, Balboa, Caicedonia"
              value={ubicacion}
              onChange={(e) => setUbicacion(e.target.value)}
            />
          </div>

          <div className={estilos.campoGrande}>
            <label>Ubicación GPS y Geocerca de la Obra</label>
            <div style={{ marginTop: '0.35rem' }}>
              <SelectorUbicacion
                punto={punto}
                onPunto={setPunto}
                direccion={ubicacion}
              />
            </div>
            {punto && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginTop: '0.6rem', fontSize: '0.85rem', color: '#e2d5fa', fontWeight: 600 }}>
                <span style={{ color: '#ffffff' }}>Radio geocerca en sitio:</span>
                <input
                  type="number"
                  min="20"
                  max="1000"
                  step="10"
                  value={radioGeocerca}
                  onChange={(e) => setRadioGeocerca(Number(e.target.value) || 80)}
                  style={{
                    width: '80px',
                    padding: '0.25rem 0.5rem',
                    borderRadius: '4px',
                    border: '1px solid #ffc43f',
                    background: '#1a0033',
                    color: '#ffffff',
                    fontWeight: 700,
                  }}
                />
                <span style={{ color: '#ffffff' }}>metros</span>
              </div>
            )}
          </div>

          <div className={estilos.campo}>
            <label>Fecha inicio</label>
            <input
              type="date"
              required
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
            />
          </div>

          <div className={estilos.campo}>
            <label>Fecha finalización</label>
            <input
              type="date"
              required
              value={fechaFin}
              onChange={(e) => setFechaFin(e.target.value)}
            />
          </div>

          <div className={estilos.campo}>
            <label>Presupuesto Total (COP)</label>
            <CampoPesos
              valor={presupuesto}
              onCambio={setPresupuesto}
              placeholder="0"
              title="Presupuesto total en COP"
            />
          </div>
        </div>

        <footer className={estilos.panelInlineFooter}>
          <button type="button" className={estilos.btnCancelar} onClick={onCerrar}>
            Cancelar
          </button>
          <button type="submit" className={estilos.btnGuardar}>
            Guardar Proyecto
          </button>
        </footer>
      </form>
    </section>
  )
}
